import { Tooltip } from "components/common/tooltip";
import { MAX_ANSWERS_LENGTH } from "features/Library/Common/constants";
import { answersLimitReached } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/utils";
import { type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import { AddButton } from "components/buttons/iconButtons/AddButton/AddButton";
import styles from "./AddSurveyAnswerButton.module.scss";

export interface AddSurveyAnswerButtonProps {
  question: SurveyQuestion<any>;
  disabled?: boolean;
  onAddAnswer: () => void;
}

export const AddSurveyAnswerButton = (props: AddSurveyAnswerButtonProps) => {
  const { disabled, question, onAddAnswer } = props;

  const inactive = answersLimitReached(question);
  const tooltipMessage = inactive
    ? "A branching question cannot have more than 5 answers. Turn off the “Branching Question” toggle at the top to add more answers."
    : "";

  return !disabled && question.answers.length < MAX_ANSWERS_LENGTH ? (
    <div className={styles.container}>
      <Tooltip
        target={<AddButton disabled={inactive} onClick={onAddAnswer} label={"Add answer"} />}
        content={tooltipMessage}
        position="top center"
        hideOnScroll
        showAlways={!!tooltipMessage}
      />
    </div>
  ) : null;
};
